import { indexItems } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">影视索引</h2>
          <p className="mt-3 text-sm text-foreground-600">按题材分类浏览，快速找到你想看的影片类型</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="block bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-primary-300/40 transition-colors group cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-950 font-heading">{item.title}</h3>
              <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-xs font-medium text-primary-500">{item.count} 部影片</span>
                <i className="ri-arrow-right-line text-sm text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}